document.addEventListener('DOMContentLoaded', function() {
    function moveAndShowContainer() {
        var mainContainer = document.querySelector('.main-container-nc');
        var targetDiv = document.querySelector('.rc-button-group__options');
        if (targetDiv) {
            targetDiv.parentNode.insertBefore(mainContainer, targetDiv.nextSibling);
            mainContainer.style.display = 'block';
            clearInterval(checkInterval);
        }
    }

    var checkInterval = setInterval(moveAndShowContainer, 100);

  
  const featureListPositive = document.querySelector('.feature-list-positive-nc');
        const featureListNegative = document.querySelector('.feature-list-negative-nc');

        function updateFeatureDisplay() {
            const subscriptionRadio = document.querySelector('.subscription-radio.rc-radio--active');
            const onetimeRadio = document.querySelector('.onetime-radio.rc-radio--active');

            if (subscriptionRadio) {
                featureListPositive.style.display = 'flex';
                featureListNegative.style.display = 'none';
            } else if (onetimeRadio) {
                featureListPositive.style.display = 'none';
                featureListNegative.style.display = 'flex';
            } else {
                // Hide both if neither is active
                featureListPositive.style.display = 'none';
                featureListNegative.style.display = 'none';
            }
        }

        // Observer to monitor DOM changes and update the display accordingly
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    updateFeatureDisplay();
                }
            });
        });

        // Configuration of the observer
        const config = { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] };

        // Start observing the document body for changes affecting control elements
        observer.observe(document.body, config);

        // Ensure display is updated at least once on page load
        updateFeatureDisplay();
});
















// // from prodcut file


// document.addEventListener("DOMContentLoaded", function () {
//   // Helper for safe DOM selection
//   function getEl(selector) {
//     return document.querySelector(selector);
//   }

//   /*****************************************
//    * A) Parse discount from subscription label
//    *****************************************/
//   function getSubscriptionDiscount() {
//     const discountLabelEl = getEl('.subscription-radio .discount-label');
//     if (!discountLabelEl) {
//       console.log("[DEBUG] No subscription discount label found.");
//       return 0;
//     }
//     const labelText = discountLabelEl.textContent;
//     const match = labelText.match(/(\d+)%/);
//     if (!match) {
//       console.log("[DEBUG] No percentage found in label:", labelText);
//       return 0;
//     }
//     return parseFloat(match[1]) || 0;
//   }

//   /*****************************************
//    * B) Parse base (one-time) price from .onetime-radio
//    *****************************************/
//   function getOneTimeBasePrice() {
//     const oneTimeLabelEl = getEl('.onetime-radio .price-label');
//     if (!oneTimeLabelEl) {
//       console.log("[DEBUG] No one-time price label found.");
//       return 0;
//     }
//     const text = oneTimeLabelEl.textContent.replace(/[^0-9.]/g, '');
//     return parseFloat(text) || 0;
//   }

//   /*****************************************
//    * C) Compute final subscription price
//    *****************************************/
//   function getDiscountedPrice() {
//     const basePrice = getOneTimeBasePrice();
//     const discountPct = getSubscriptionDiscount();
//     return basePrice * (1 - discountPct / 100);
//   }

//   /*****************************************
//    * D) Determine pack size by reading select value
//    *****************************************/
//   function getPackSize() {
//     const selectEl = getEl('.pack-size-selector'); // Use a class instead of a static ID
//     if (!selectEl) return 1;
//     const val = selectEl.value.toLowerCase();
//     if (val.includes('12')) return 12;
//     if (val.includes('5')) return 5;
//     return 1; // fallback
//   }

//   /*****************************************
//    * E) Main update function
//    *****************************************/
//   function updatePrices() {
//     const subscriptionRadio = getEl('#rc-radio1');
//     const oneTimeRadio = getEl('#rc-radio2');
//     const addToCartBtnText = getEl('.add-to-cart-btn span[x-text="addToCartText"]');
//     const addToCartBtnPrice = getEl('.add-to-cart-btn span[x-html="formatMoney(currentPrice)"]');
//     const subPriceSpan = getEl('.nc-regular-subs-price');
//     const mainPriceSpan = getEl('span.text-scheme-text.text-base.lg\\:text-lg[x-html="formatMoney(currentPrice)"]');
//     const perBottleSpan = getEl('.nc-per-bottle-price');

//     if (!subscriptionRadio || !oneTimeRadio || !addToCartBtnText || !addToCartBtnPrice || !subPriceSpan || !mainPriceSpan) {
//       console.log("[DEBUG] Missing some required elements for price update.");
//       return;
//     }

//     let finalPrice = 0;

//     if (subscriptionRadio.checked) {
//       finalPrice = getDiscountedPrice();
//       addToCartBtnText.textContent = "Add to Subscription";
//       addToCartBtnPrice.textContent = `$${finalPrice.toFixed(2)}`;
//       subPriceSpan.textContent = `$${finalPrice.toFixed(2)}`;
//       subPriceSpan.classList.remove('sr-only');
//       mainPriceSpan.classList.add('sr-only');
//     } else {
//       finalPrice = getOneTimeBasePrice();
//       addToCartBtnText.textContent = "Add to Cart";
//       addToCartBtnPrice.textContent = `$${finalPrice.toFixed(2)}`;
//       subPriceSpan.textContent = originalNcRegularSubsText;
//       subPriceSpan.classList.add('sr-only');
//       mainPriceSpan.classList.remove('sr-only');
//     }

//     // Update per-bottle price
//     if (perBottleSpan) {
//       const packSize = getPackSize();
//       const perBottle = finalPrice / packSize;
//       perBottleSpan.textContent = `$${perBottle.toFixed(2)}`;
//     }
//   }

//   /*****************************************
//    * Observe changes to discount label
//    *****************************************/
//   function observeDiscountLabel() {
//     const discountLabel = getEl('.subscription-radio .discount-label');
//     if (!discountLabel) return;
//     const observer = new MutationObserver(updatePrices);
//     observer.observe(discountLabel, {
//       childList: true,
//       characterData: true,
//       subtree: true,
//     });
//   }

//   /*****************************************
//    * Observe changes to the Add-to-Cart button text
//    *****************************************/
//   function observeAddToCartButton() {
//     const addToCartBtnText = getEl('.add-to-cart-btn span[x-text="addToCartText"]');
//     if (!addToCartBtnText) return;
//     const observer = new MutationObserver(updatePrices);
//     observer.observe(addToCartBtnText, {
//       childList: true,
//       characterData: true,
//       subtree: true,
//     });
//   }

//   /*****************************************
//    * Setup radio changes
//    *****************************************/
//   function setupRadioListeners() {
//     const subscriptionRadio = getEl('#rc-radio1');
//     const oneTimeRadio = getEl('#rc-radio2');
//     if (subscriptionRadio && oneTimeRadio) {
//       subscriptionRadio.addEventListener('change', updatePrices);
//       oneTimeRadio.addEventListener('change', updatePrices);
//     }
//   }

//   /*****************************************
//    * Setup variant (pack size) changes
//    *****************************************/
//   function setupPackSizeListener() {
//     const selectEl = getEl('.pack-size-selector'); // Use a class instead of a static ID
//     if (selectEl) {
//       selectEl.addEventListener('change', updatePrices);
//     }
//   }

//   /*****************************************
//    * Store original text in .nc-regular-subs-price
//    *****************************************/
//   function storeOriginalSubsText() {
//     const subPriceSpan = getEl('.nc-regular-subs-price');
//     if (subPriceSpan) {
//       originalNcRegularSubsText = subPriceSpan.textContent.trim();
//     }
//   }

//   /*****************************************
//    * Main initialization
//    *****************************************/
//   let initAttempts = 0;
//   const initInterval = setInterval(function () {
//     initAttempts++;
//     console.log(`[DEBUG] Attempt #${initAttempts} to initialize script...`);

//     const subscriptionRadio = getEl('#rc-radio1');
//     const oneTimeRadio = getEl('#rc-radio2');
//     const addToCartBtnText = getEl('.add-to-cart-btn span[x-text="addToCartText"]');
//     const addToCartBtnPrice = getEl('.add-to-cart-btn span[x-html="formatMoney(currentPrice)"]');
//     const discountLabel = getEl('.subscription-radio .discount-label');
//     const oneTimeLabel = getEl('.onetime-radio .price-label');
//     const subPriceSpan = getEl('.nc-regular-subs-price');
//     const mainPriceSpan = getEl('span.text-scheme-text.text-base.lg\\:text-lg[x-html="formatMoney(currentPrice)"]');
//     const perBottleSpan = getEl('.nc-per-bottle-price');

//     if (
//       subscriptionRadio &&
//       oneTimeRadio &&
//       addToCartBtnText &&
//       addToCartBtnPrice &&
//       discountLabel &&
//       oneTimeLabel &&
//       subPriceSpan &&
//       mainPriceSpan &&
//       perBottleSpan
//     ) {
//       console.log("[DEBUG] All required elements found. Initializing...");

//       storeOriginalSubsText();
//       observeDiscountLabel();
//       observeAddToCartButton();
//       setupRadioListeners();
//       setupPackSizeListener();
//       updatePrices();

//       clearInterval(initInterval);
//     }

//     if (initAttempts > 20) {
//       console.log("[DEBUG] Gave up after 20 attempts. Some elements never appeared.");
//       clearInterval(initInterval);
//     }
//   }, 500);
// });










// per bottle calculations


  // // Function to calculate and display the price per bottle
  // function updatePricePerBottle() {
  //   // Get the metafield value (number of bottles in a pack)
  //   const bottlesInPackElement = document.querySelector('.per-bottle-price-matfeild-value');
  //   const bottlesInPack = parseFloat(bottlesInPackElement.textContent);

  //   // Get the product price
  //   const productPriceElement = document.querySelector('[data-product-price]');
  //   const productPriceText = productPriceElement.textContent.replace('$', '').replace(',', '');
  //   const productPrice = parseFloat(productPriceText);

  //   // Debugging: Log values to the console
  //   console.log('Bottles in Pack:', bottlesInPack);
  //   console.log('Product Price:', productPrice);

  //   // Check if both values are valid
  //   if (bottlesInPack && productPrice) {
  //     // Calculate the price per bottle
  //     const pricePerBottle = productPrice / bottlesInPack;

  //     // Debugging: Log the calculated price
  //     console.log('Price per Bottle:', pricePerBottle);

  //     // Format the price to 2 decimal places
  //     const formattedPrice = `$${pricePerBottle.toFixed(2)}`;

  //     // Update the DOM with the calculated price
  //     const perBottleElement = document.querySelector('.nc-per-bottle-price');
  //     if (perBottleElement) {
  //       perBottleElement.textContent = formattedPrice;
  //     }
  //   } else {
  //     console.error('Invalid metafield value or product price.');
  //   }
  // }

  // // Initial calculation
  // updatePricePerBottle();

  // // Listen for variant changes (if applicable)
  // document.addEventListener('variant:change', function(event) {
  //   // Recalculate the price per bottle when the variant changes
  //   updatePricePerBottle();
  // });

  // // Optional: Add a mutation observer to detect price changes
  // const priceObserver = new MutationObserver(updatePricePerBottle);
  // const priceElement = document.querySelector('[data-product-price]');
  // if (priceElement) {
  //   priceObserver.observe(priceElement, { childList: true, subtree: true, characterData: true });
  // }